import { combineReducers } from 'redux'
import authReducer from './authReducer'

// to combine all reducers together
const rootReducer = combineReducers({
    authReducer,
})

export default rootReducer
